import React from "react";

import "./Deprecated.css";

export default function Deprecated() {
  return (
    <div className="deprecated-inner d-flex flex-column align-items-center justify-content-center text-center px-3">
      <h2 className="mb-3">CoinStats Affiliate Dashboard is deprecated</h2>
      <p className="deprecated-text">
        Please contact the CoinStats team for your affiliate data while we're
        building a new one.
      </p>
    </div>
  );
}
